import images from "./images";

const Coding = [
  {
    title: "Leetcode Profile",
    description: "Problem solving on Leetcode",
    ProjectLink: "https://leetcode.com/psdoiphode2000/",
    codeLink: "",
    imageUrl: images.leetcode,
  },
  {
    title: "Github Profile",
    description: "Projects on Github",
    ProjectLink: process.env.REACT_APP_GITHUB,
    codeLink: "",
    imageUrl: images.github,
  },
  {
    title: "CodingNinja Profile",
    description: "Problem solving on CodingNinja",
    ProjectLink:
      "https://www.codingninjas.com/codestudio/profile/746177e3-eb51-4a29-b565-79a03acfccfd",
    codeLink: "",
    imageUrl: images.codingninjas,
  },
  {
    title: "HackerRank Profile",
    description: "Problem solving on HackerRank",
    ProjectLink: "https://www.hackerrank.com/psdoiphode2000",
    codeLink: "",
    imageUrl: images.hackerrank,
  },
];

export default Coding;
